var exports = {
  "promoLabel-wrapper": "xcc377c0b--78e8cd--promoLabel-wrapper",
  "promoLabel-container": "xcc377c0b--78e8cd--promoLabel-container",
  "promoLabel-iconContainer": "xcc377c0b--78e8cd--promoLabel-iconContainer",
  "promoLabel-iconContainer--discount": "xcc377c0b--78e8cd--promoLabel-iconContainer--discount",
  "promoLabel-iconContainer--mortgage": "xcc377c0b--78e8cd--promoLabel-iconContainer--mortgage",
  "promoLabel-iconContainer--bonus": "xcc377c0b--78e8cd--promoLabel-iconContainer--bonus",
  "promoLabel-tooltipContainer": "xcc377c0b--78e8cd--promoLabel-tooltipContainer",
  "promoLabel-iconLink": "xcc377c0b--78e8cd--promoLabel-iconLink",
};

module.exports = exports;
